import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

interface Artwork {
  hash: string
  title: string
  image: string
}

@Component
export default class ArtworkView extends Vue {
  private artworks: Artwork[] = []

  public get artworkHash(): string {
    return this.$route.params.hash
  }

  public get artworkIndex(): number {
    return this.artworks.findIndex((artwork: any) => {
      return artwork.hash === this.artworkHash
    })
  }

  public get artwork(): Artwork | null {
    const index = this.artworkIndex
    if (index !== -1) {
      return this.artworks[index]
    }
  }

  public get nextArtwork(): Artwork | null {
    const index = this.artworkIndex
    if (index < (this.artworks.length - 1)) {
      return this.artworks[index + 1]
    }
  }

  public get prevArtwork(): Artwork | null {
    const index = this.artworkIndex
    if (index >= 1) {
      return this.artworks[index - 1]
    }
  }

  public closeArtwork() {
    this.$router.push({ name: 'artists.view' })
  }

  public getRouteForArtwork(artwork: Artwork) {
    if (! artwork) {
      return
    }

    return {
      name: 'artworks.view',
      params: {
        hash: artwork.hash,
      },
    }
  }

  private mounted() {
    this.artworks = _state.artworks
    document.addEventListener('keydown', this.handleKeyboardEvent)

    document.body.classList.add('modal-open')
  }

  private beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeyboardEvent)

    document.body.classList.remove('modal-open')
  }

  private handleKeyboardEvent(event: KeyboardEvent) {
    let route
    if (event.keyCode === 27) {
      // ESCAPE
      this.closeArtwork()
      return
    }

    if (event.keyCode === 37) {
      // LEFT
      route = this.getRouteForArtwork(this.prevArtwork)
    }

    if (event.keyCode === 39) {
      // RIGHT
      route = this.getRouteForArtwork(this.nextArtwork)
    }

    if (route) {
      this.$router.push(route)
    }
  }
}
